declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID_1 = '855275007473565'
const PIXEL_ID_2 = '1379391876531260'

export function initFacebookPixels(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  // Set up fbq function
  const n: any = (window.fbq = function () {
    if (n.callMethod) {
      n.callMethod.apply(n, arguments)
    } else {
      n.queue.push(arguments)
    }
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the Facebook Pixel script safely
  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  // Initialize both pixels
  window.fbq('init', PIXEL_ID_1)
  window.fbq('init', PIXEL_ID_2)

  // Fire PageView for both pixels
  window.fbq('track', 'PageView')

  // Fire additional events for Pixel 2
  window.fbq('trackSingle', PIXEL_ID_2, 'ViewContent')
  window.fbq('trackSingle', PIXEL_ID_2, 'Lead')
  window.fbq('trackSingle', PIXEL_ID_2, 'AddToWishlist')
}

export function trackInitiateCheckout(): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return

  // Fire InitiateCheckout on both pixels
  window.fbq('track', 'InitiateCheckout', {
    content_name: 'Método Colon Feliz',
    content_category: 'Ebook',
    value: 6.39,
    currency: 'USD',
  })
}
